import { Component, ComponentFactoryResolver, ComponentRef, OnChanges, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { CorePageBaseComponent } from '../core-page-base.component';

import { WorkflowPageNavigationService } from '../../../../service/workflow-page-navigation/workflow-page-navigation.service';
import { WorkflowWidgetEventServiceService } from '../../../../widget/workflow-widget-event.service';
import { workflowModalRegistry } from '../../../shared/workflow-registries';
@Component({
  selector: 'cu-dynamic-page-modal-popup',
  template: ` <ea-modal
    [isModalVisible]="page.modalVisible"
    [hideModalHeader]="true"
    id="page-custom-modal"
    closeModalElementId="custom-modal-close"
  >
    <ng-container #modalContainer></ng-container>
  </ea-modal>`
})
export class PageModalComponent extends CorePageBaseComponent implements OnInit, OnChanges {
  @ViewChild('modalContainer', { static: true, read: ViewContainerRef })
  public modalContainer: ViewContainerRef;

  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    public wfPageNavService: WorkflowPageNavigationService,
    public readonly widgetEventService: WorkflowWidgetEventServiceService
  ) {
    super(wfPageNavService, widgetEventService);
  }

  ngOnInit(): void {
    if (this.page.modalVisible) {
      this.modalResolver(this.page.customModalType);
    }
  }

  ngOnChanges(): void {
    // This is to reset the save/continue button to enabled state
    // if a custom modal pops up after save button is clicked
    this.page.continueButtonDisabled = !this.page.modalVisible;
  }

  private modalResolver(type: string): void {
    const pageInstance = workflowModalRegistry[type];
    if (!pageInstance) {
      throw new Error(`No Modal has been registered for type '${type}' in page id '${this.page.id}'. `);
    }

    const factory = this.componentFactoryResolver.resolveComponentFactory(pageInstance);
    const component = this.modalContainer.createComponent(factory) as ComponentRef<CorePageBaseComponent>;
    component.instance.page = this.page;
    component.instance.flow = this.flow;
  }
}
